module.exports = __webpack_public_path__ + "static/media/antonio.88c1a279.jpg";